export function Required({ required }: { required?: boolean }) {
  if (required) {
    return <span className="text-red-600"> *</span>;
  } else {
    return null;
  }
}
